import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withTranslation } from 'react-i18next';
import CancelPromisesHOC   from "../../helpers/cancelPromisesHOC";
import { withRouter } from "react-router-dom";
import *  as navigationActions from '../../redux/actions/navigationActions';
import {setCurrentModule} from "../../utils/navigationUtil";
import UsersManagementList from "../common/Lists/usersManagementList";
import * as UsersActions from "../../redux/actions/usersActions";


export class UsersManagement extends Component {    
    componentDidMount(){
        this.props.actions.setModule(setCurrentModule('/usersManagement'));
    }
    render() {
        return (
            <UsersManagementList {...this.props} />
        )
    };
}

function mapStateToProps(state) {
    return {
        users: state.users,
        moduleInfo: state.navigation.module,
        user: state.oidc.user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            setModule: bindActionCreators(navigationActions.setModule, dispatch),
            ReadUsers: bindActionCreators(UsersActions.ReadUsers, dispatch),
            deleteUser:  bindActionCreators(UsersActions.deleteUser, dispatch),
        }
    };
  }

export default compose(withTranslation('common'),
CancelPromisesHOC,
connect(
    mapStateToProps,
    mapDispatchToProps,
))(withRouter(UsersManagement));